import React from "react";
import useAppTranslation from "../../hooks/useAppTranslation";

const StoryContentToggle = ({
  showTitleOnCover,
  setShowTitleOnCover,
  imageOnlyIcon = "/images/utils/button/cover-on.svg",
  showTextIcon = "/images/utils/button/contents-on.svg",
}) => {
  const { t } = useAppTranslation("components/utils/storyContentToggle");

  return (
    <div className="story-content-toggle">
      <button
        className={`toggle-option ${!showTitleOnCover ? "active" : ""}`}
        onClick={(e) => {
          e.stopPropagation();
          setShowTitleOnCover(false);
        }}
      >
        <img
          src={imageOnlyIcon}
          alt=""
          loading="lazy"
          decoding="async"
        />
        {t("imageOnly")}
      </button>
      <button
        className={`toggle-option ${showTitleOnCover ? "active" : ""}`}
        onClick={(e) => {
          e.stopPropagation();
          setShowTitleOnCover(true);
        }}
      >
        <img
          src={showTextIcon}
          alt=""
          loading="lazy"
          decoding="async"
        />
        {t("showText")}
      </button>
    </div>
  );
};

export default StoryContentToggle;
